// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-navigation-footer[data-v-1b95d1d4]{position:absolute;bottom:0;z-index:999;background-color:#fff;padding:1rem 2rem;left:50%;transform:translateX(-50%)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
